// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a5071cb8","453":"b508a6a3","777":"c43646fc"}[chunkId] + ".chunk.js";
};